export default "__VITE_ASSET__CCHHQGmW__"